module.exports = __webpack_public_path__ + "static/media/compass.fc9efd2a.png";